import { motion } from "framer-motion";
import { useState } from "react";
import { Phone, Mail } from "lucide-react";
import emailjs from "@emailjs/browser";

const locations = [
  {
    name: "Camera Service Centre",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.4871825312953!2d80.2674737105977!3d13.068280987202872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52661b7121f617%3A0x81a39f54b9854c93!2sCamera%20Service%20Centre!5e0!3m2!1sen!2sin!4v1750096918964!5m2!1sen!2sin",
    address: [
      "No- 3, Shop No - 5, Vijayashanthi  Building, Blackers Road,",
      "Annna Salai, Mount Road,",
      "Chennai - 600 002",
      "Next to Casino Theatre ",
    ],
    phone: "044 28594392 / 28413513",
    email: "cameraservicecentre@vsnl.net",
  },
  {
    name: "Canon Camera Service Centre",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.4871825312953!2d80.2674737105977!3d13.068280987202872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52661b7121f617%3A0x81a39f54b9854c93!2sCamera%20Service%20Centre!5e0!3m2!1sen!2sin!4v1750096918964!5m2!1sen!2sin",
    address: [
      "No- 3, Shop No - 5, Vijayashanthi  Building, Blackers Road,",
      "Annna Salai, Mount Road,",
      "Chennai - 600 002",
      "Next to Casino Theatre ",
    ],
    phone: "044 242101331",
    email: "canon.asfchennai@gmail.com",
  },
  {
    name: "Nikon Authorized Service Centre",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.213668379715!2d80.24514681059796!3d13.085640687187064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265d940187e61%3A0x309ac84559f336c4!2sNikon%20Authorized%20service%20centre!5e0!3m2!1sen!2sin!4v1750097172874!5m2!1sen!2sin",
    address: [
      "No - F18, First floor,",
      "Prince Towers,",
      "Kellys, Purasawakkam high road,",
      "Chennai -  600 010",
    ],
    phone: "044-242041424 / 242041425",
    email: "cameraservicecentre@gmail.com",
  },
  {
    name: "Nikon Camera Authorised Centre",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5558.105950238367!2d78.1447538443738!3d9.919509553916255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c5aeeeb7a275%3A0xc145753fcd51fd58!2sNikon%20Camera%20Authorised%20collection%20Centre!5e0!3m2!1sen!2sin!4v1750097287823!5m2!1sen!2sin",
    address: [
      "MIG.347, 2nd Floor, NR Complex,",
      "80 Feet Road, Anna Nagar,",
      "Madurai- 625 020",
    ],
    phone: "0452 - 4250601",
    email: "nccmadurai@gmail.com",
  },
  {
    name: "Nikon Camera Service Spot",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d477.8089710885314!2d76.9647401297651!3d11.013157061312372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859f906050d1f%3A0x76c7f1e15783e26a!2sNikon%20Camera%20Service%20Spot!5e0!3m2!1sen!2sin!4v1750097236360!5m2!1sen!2sin",
    address: ["No.9 Ramar kovil street, Ramnagar,", "coimbatore –641009"],
    phone: "9445228928",
    email: null,
  },
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // EmailJS configuration
      const templateParams = {
        to_email: "cameraservicecentre@gmail.com",
        name: formData.name,
        email: formData.email,
        message: formData.message,
        subject: `Contact Form Submission from ${formData.name}`,
      };

      // Send email using EmailJS
      const response = await emailjs.send(
        "service_6acf49c", // Replace with your EmailJS service ID
        "template_bnlujvk", // Replace with your EmailJS template ID
        templateParams,
        "eHIAYeC22EnhD88Ll" // Replace with your EmailJS public key
      );

      if (response.status === 200) {
        setSubmitStatus("success");
        // Reset form
        setFormData({ name: "", email: "", message: "" });
      }
    } catch (error) {
      console.error("Email sending failed:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="container py-20">
      {/* Contact Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl font-bold mb-6">Contact Us</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Have questions? We're here to help. Reach out to us through any of the
          following methods.
        </p>
      </motion.div>

      {/* 3x2 Grid Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Contact Form */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-muted/50 p-8 rounded-lg"
        >
          <h2 className="text-2xl font-bold mb-6">Send us a Message</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium mb-2">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-md border border-input bg-background"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-md border border-input bg-background"
                required
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium mb-2"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                className="w-full px-4 py-2 rounded-md border border-input bg-background"
                required
              />
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? "Sending..." : "Send Message"}
            </button>

            {/* Status Messages */}
            {submitStatus === "success" && (
              <div className="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded-md">
                Message sent successfully! We'll get back to you soon.
              </div>
            )}

            {submitStatus === "error" && (
              <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md">
                Failed to send message. Please try again later.
              </div>
            )}
          </form>
        </motion.div>

        {/* Locations as grid items */}
        {locations.map((loc, idx) => (
          <motion.div
            key={loc.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            className="bg-muted/50 p-6 rounded-lg flex flex-col"
          >
            <h2 className="text-xl font-bold mb-2">{loc.name}</h2>
            <div className="aspect-video bg-muted rounded-lg overflow-hidden mb-4">
              <iframe
                src={loc.iframe}
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={loc.name}
              ></iframe>
            </div>
            <div className="mb-2">
              {loc.address.map((line, i) => (
                <div key={i} className="text-muted-foreground text-sm">
                  {line}
                </div>
              ))}
            </div>
            {loc.phone && (
              <div className="flex items-center gap-2 text-sm mb-1">
                <Phone className="h-4 w-4 text-primary" />
                <span className="text-muted-foreground">{loc.phone}</span>
              </div>
            )}
            {loc.email && (
              <div className="flex items-center gap-2 text-sm">
                <Mail className="h-4 w-4 text-primary" />
                <span className="text-muted-foreground">{loc.email}</span>
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Contact;
